import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToolbarTabsModule } from '@components/toolbar-tabs';
import { ButtonModule } from '@components/button';
import { ToolbarModule } from '@components/toolbar';
import { DirectivesModule } from '@directives/directives.module';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { SwiperModule } from 'swiper/angular';
import { RouterModule } from '@angular/router';
import { ReportCardModule } from '@shared/report-card/report-card.module';
import { CustomPipeModule } from '@components/custom-pipe/custom-pipe.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { UserCheckupComponent } from './user-checkup.component';
import { UserFollowupComponent } from './user-followup/user-followup.component';
import { authenticationGuard } from '../guards/authentication.guard';
import { onboardingGuard } from '../guards/onboarding.guard';
import { RegimenExpiryStripComponent } from '@shared/home-banners/regimen-expiry-strip/regimen-expiry-strip.component';
import { RegimenExpiredStripComponent } from '@shared/home-banners/regimen-expired-strip/regimen-expired-strip.component';
import { InvestigationStripComponent } from '@shared/home-banners/investigation-strip/investigation-strip.component';
import { InvestigationSheetComponent } from '@shared/bottom-sheet-layouts/investigation-sheet/investigation-sheet.component';

@NgModule({
  imports: [
    FormsModule,
    RouterModule.forChild([
      {
        path: 'checkup',
        canActivate: [authenticationGuard, onboardingGuard],
        component: UserCheckupComponent,
      },
    ]),
    CommonModule,
    ToolbarTabsModule,
    ButtonModule,
    LoadingModule,
    ToolbarModule,
    DirectivesModule,
    CsIconModule,
    RouterModule,
    ReportCardModule,
    SwiperModule,
    CustomPipeModule,
    RegimenExpiryStripComponent,
    RegimenExpiredStripComponent,
    MatBottomSheetModule,
    InvestigationStripComponent,
    InvestigationSheetComponent,
  ],
  declarations: [UserCheckupComponent, UserFollowupComponent],
  exports: [UserCheckupComponent, UserFollowupComponent],
})
export class UserCheckupModule { }
